import { Roles } from "../../../../infrastructure/enums";
import { ZoneDistrictRefs } from "../../../constants";
import { isNullOrUndefined } from "../../../../../../tools";
import { IdProvider } from "../../../../../services/idprovider.service";
import { ServerCommunicatorService } from "../../../../../services/server-communicator.service";
import { UIUtils } from "../../../../../services/uiutils.service";
import { Utils } from "../../../../../services/utils.service";
import { DataContainer } from "../../../../infrastructure/datacontainer";
import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../infrastructure/enums";
import { IPersistable } from "../../../../infrastructure/IPersistable";
import { PayloadPacketFacade } from "../../../../infrastructure/payloadpacket/payloadpacketfacade";
import { TransportData } from "../../../../infrastructure/transportdata";
import { ValidationResultAccumulator } from "../../../../infrastructure/validationresultaccumulator";
import { DashboardDropdownHierarchyFetchRequest } from "./dashboarddropdownhierarchyfetchrequest";

export class DashboardDropdownHierarchyProps {

    public CreatedDate: string = '';
    public UpdatedDate: string = '';
    public CreatedBy: number = 0;
    public UpdatedBy: number = 0;
    public Ref: number = 0;

    //Asha Details
    public AshaEmployeeRecordRef: number = 0;
    public AshaFullName: string = '';

    //AF Details
    public AFEmployeeRecordRef: number = 0;
    public AFFullName: string = '';
    public AFPostRef: number = 0;
    public AFPostName: string = '';

    //BCM Details
    public BCMPostRef: number = 0;
    public BCMPostName: string = '';


    //Location Details
    public VillageRef: number = 0;
    public VillageNameEn: string = '';

    public SCRef: number = 0;
    public SCName: string = '';

    public PHCRef: number = 0;
    public PHCName: string = '';

    public BlockRef: number = 0;
    public BlockNameEn: string = '';

    public DistrictRef: number = 0;
    public DistrictNameEn: string = '';

    public ZoneRef: number = 0;
    public ZoneName: string = '';

    public StateRef: number = 0;
    public StateNameEn: string = '';


    public readonly IsNewlyCreated: boolean = false;


    private constructor(isNewlyCreated: boolean) {
        this.IsNewlyCreated = isNewlyCreated;
    }

    public static Blank() {
        return new DashboardDropdownHierarchyProps(true);
    }
}

export class DashboardDropdownHierarchy implements IPersistable<DashboardDropdownHierarchy> {
    public static readonly MasterTableName: string = 'DashboardDropdownHierarchy';

    private constructor(public readonly p: DashboardDropdownHierarchyProps, public readonly AllowEdit: boolean) {

    }

    public async EnsurePrimaryKeysWithValidValues(): Promise<void> {
        if (this.p.Ref === undefined || this.p.Ref === 0) {
            const newRefs = await IdProvider.GetInstance().GetNextEntityId();
            // const newRefs = await IdProvider.GetInstance().GetAllocateSingleIds();
            this.p.Ref = newRefs[0];
            if (this.p.Ref <= 0) throw new Error("Cannot assign Id. Please try again");
        }
    }

    public GetEditableVersion(): DashboardDropdownHierarchy {
        let newDashboardDropdownHierarchy: DashboardDropdownHierarchyProps = Utils.GetInstance().DeepCopy(this.p);
        return DashboardDropdownHierarchy.CreateInstance(newDashboardDropdownHierarchy, true);
    }

    public static CreateNewInstance() {
        return new DashboardDropdownHierarchy(DashboardDropdownHierarchyProps.Blank(), true);
    }

    public static CreateInstance(data: any, allowEdit: boolean) {
        return new DashboardDropdownHierarchy(data as DashboardDropdownHierarchyProps, allowEdit);
    }

    public CheckSaveValidity(_td: TransportData, vra: ValidationResultAccumulator): void {
        if (!this.AllowEdit) vra.add('', 'This object is not editable and hence cannot be saved.');
        // if (this.p.StateRef <= 0) {
        //     vra.add('StateRef', 'State cannot be blank.');
        // }
        // if (this.p.ZoneRef <= 0) {
        //     vra.add('ZoneRef', 'Zone cannot be blank.');
        // }
        // if (this.p.DistrictRef <= 0) {
        //     vra.add('DistrictRef', 'District cannot be blank.');
        // }
        // if (this.p.BlockRef <= 0) {
        //     vra.add('BlockRef', 'Block cannot be blank.');
        // }
        // if (this.p.PHCRef <= 0) {
        //     vra.add('PHCRef', 'PHC cannot be blank.');
        // }
        // if (this.p.SCRef <= 0) {
        //     vra.add('SCRef', 'SC cannot be blank.');
        // }
        // if (this.p.UnderSupervision <= 0) {
        //     vra.add('UnderSupervision', 'Under Supervision cannot be blank.');
        // }
        // if (this.p.PopulationCoveredByAsha <= 0) {
        //   vra.add('PopulationCoveredByAsha', 'Population Covered By Asha cannot be blank.');
        // }
        // if (this.p.PopulationCoveredByAsha == null || this.p.PopulationCoveredByAsha === 0) {
        //   vra.add('PopulationCoveredByAsha', 'Population Covered By Asha is required.');
        // } else if (this.p.PopulationCoveredByAsha <= 0) {
        //   vra.add('PopulationCoveredByAsha', 'Population Covered By Asha must be greater than 0.');
        // }
        // if (this.p.appoinment_date_from == '') {
        //     vra.add('AppoinmentDateFrom', 'Appoinment Date cannot be blank.');
        // }
        // if (this.p.DashboardDropdownHierarchyRef <= 0) vra.add('DashboardDropdownHierarchyRef', 'DashboardDropdownHierarchy cannot be blank. ');
        // if (this.p.CityRef <= 0) vra.add('CityRef', 'City cannot be blank. ');
    }

    public MergeIntoTransportData(td: TransportData) {
        DataContainerService.GetInstance().MergeIntoContainer(td.MainData, DashboardDropdownHierarchy.MasterTableName, this.p);
    }

    private static m_currentInstance: DashboardDropdownHierarchy = DashboardDropdownHierarchy.CreateNewInstance();

    public static GetCurrentInstance() {
        return DashboardDropdownHierarchy.m_currentInstance;
    }

    public static SetCurrentInstance(value: DashboardDropdownHierarchy) {
        DashboardDropdownHierarchy.m_currentInstance = value;
    }

    // ********************************************
    public static cacheDataChangeLevel: number = -1;

    public static SingleInstanceFromTransportData(td: TransportData): DashboardDropdownHierarchy {
        let dcs = DataContainerService.GetInstance();
        if (dcs.CollectionExists(td.MainData, DashboardDropdownHierarchy.MasterTableName)) {
            for (let data of dcs.GetCollection(td.MainData, DashboardDropdownHierarchy.MasterTableName)!.Entries) {
                return DashboardDropdownHierarchy.CreateInstance(data, false);
            }
        }

        return null as any;
    }

    public static ListFromDataContainer(cont: DataContainer,
        filterPredicate: (arg0: any) => boolean = null as any,
        sortPropertyName: string = "Name"): DashboardDropdownHierarchy[] {
        let result: DashboardDropdownHierarchy[] = [];

        let dcs = DataContainerService.GetInstance();

        if (dcs.CollectionExists(cont, DashboardDropdownHierarchy.MasterTableName)) {
            let coll = dcs.GetCollection(cont, DashboardDropdownHierarchy.MasterTableName)!;
            let entries = coll.Entries;

            if (!isNullOrUndefined(filterPredicate)) entries = entries.filter(filterPredicate);

            if (sortPropertyName.trim().length > 0) {
                entries = Utils.OrderByPropertyName(entries, sortPropertyName);
            }

            for (let data of entries) {
                result.push(DashboardDropdownHierarchy.CreateInstance(data, false));
            }
        }

        return result;
    }

    public static ListFromTransportData(td: TransportData): DashboardDropdownHierarchy[] {
        return DashboardDropdownHierarchy.ListFromDataContainer(td.MainData);
    }

    public static async FetchTransportData(req: DashboardDropdownHierarchyFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
        let tdRequest = req.FormulateTransportData();
        let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

        let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
        if (!tr.Successful) {
            if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
            return null;
        }

        let tdResponse = JSON.parse(tr.Tag) as TransportData;
        return tdResponse;
    }

    public static async FetchEntireListByFilter(FinancialYearRef: number, IncentiveRole: number, FilterType: number, HalfYearType: number, QuarterlyYearType: number, Month: number,
        toDate: string, fromDate: string, uptolevel: number, StateRef: number[],
        ZoneRef: number[], DistrictRef: number[], BlockRef: number[], BCMPostRef: number[], PHCRef: number[], AFRef: number[], SCRef: number[], VillageRef: number[], AshaRef: number[],
        errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
        let req = new DashboardDropdownHierarchyFetchRequest();
        // debugger
        req.FinancialYearRef = FinancialYearRef;
        req.IncentiveRole = IncentiveRole;
        req.ReportFilterType = FilterType;
        req.HalfYearType = HalfYearType;
        req.QuarterlyYearType = QuarterlyYearType;
        req.Month = Month;
        req.ToDate = toDate;
        req.FromDate = fromDate;

        req.DropdownHierarchyLevel = uptolevel;

        req.StateRefs.push(...StateRef);
        req.ZoneRefs.push(...ZoneRef);
        req.DistrictRefs.push(...DistrictRef);
        req.BlockRefs.push(...BlockRef);
        req.BCMPostRefs.push(...BCMPostRef);
        req.PHCRefs.push(...PHCRef);
        req.AFRefs.push(...AFRef);
        req.SCRefs.push(...SCRef);
        req.VillageRefs.push(...VillageRef);
        req.AshaRefs.push(...AshaRef);

        let tdResponse = await DashboardDropdownHierarchy.FetchTransportData(req, errorHandler) as TransportData;
        return DashboardDropdownHierarchy.ListFromTransportData(tdResponse);
    }

    public async DeleteInstance(): Promise<boolean> {
        let tdRequest = new TransportData();
        tdRequest.RequestType = RequestTypes.Deletion;

        this.MergeIntoTransportData(tdRequest);

        let pktRequest =
            PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

        let tr = await ServerCommunicatorService
            .GetInstance()
            .sendHttpRequest(pktRequest);

        if (!tr.Successful) {
            await UIUtils.GetInstance().GlobalUIErrorHandler(tr.Message);
            return false; // ❌ STOP
        }

        return true; // ✅ SUCCESS
    }

}
